import Countries from '../../util/countries';

export default class Presenter {
  constructor(model, onClose, onComplete, onError) {
    this.model = model;
    this.onClose = onClose;
    this.onComplete = onComplete;
    this.onError = onError;
  }

  async onAttach() {
    Countries.get().then((countries) => {
      this.model.countries = countries;
    });
  }

  onCountrySelect(country) {
    this.onComplete?.(country);
  }

  onCloseClick() {
    this.onClose?.();
  }
}
